import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/our-story", label: "Our Story" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-[#FAF8F5]/90 backdrop-blur-md border-b border-[#E6DFD3]"
    >
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-7xl flex items-center justify-between h-20">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src="/wayside/logo-ink.png" alt="Wayside Orchard" className="h-10 md:h-11 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(" ", "-")}`}
              className={({ isActive }) =>
                `font-sans text-sm uppercase tracking-widest transition-colors duration-200 hover:text-[#B85C38] ${
                  isActive ? "text-[#B85C38]" : "text-[#4A5D4E]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="open-cart-button"
            onClick={() => setOpen(true)}
            className="relative p-2 text-[#2D372B] hover:text-[#B85C38] transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-6 h-6" />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-1 -right-1 bg-[#B85C38] text-white text-[11px] font-medium w-5 h-5 rounded-full flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2 text-[#2D372B]"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Menu"
            data-testid="mobile-menu-button"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-[#E6DFD3] bg-[#FAF8F5] px-6 py-4 flex flex-col gap-4">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={() => setMobileOpen(false)}
              className="font-sans text-sm uppercase tracking-widest text-[#4A5D4E]"
            >
              {n.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}
